import { createLogger, type Environment } from "@stb/core/logger"

import { getAppMode, type AppMode } from "./mode"

const ENVIRONMENT_BY_MODE: Record<AppMode, Environment> = {
  production: "production",
  preview: "staging",
  development: "development",
  test: "test",
}

/** Application-wide structured logger; use `logger.child({ ... })` to add context. */
export const logger = createLogger({
  environment: ENVIRONMENT_BY_MODE[getAppMode()],
  bindings: { service: "web" },
})
